/**
 * Looks pages — lightweight page fade on internal navigation.
 * Mirrors live router.js fade (is-faded / 400ms) without SPA; scoped to .looks pages.
 */
(function () {
  const TRANSITION_MS = 400;
  const STORAGE_KEY = 'looksPageTransition';

  function hasLooksPage() {
    return !!document.querySelector('.looks');
  }

  function isModifiedClick(ev) {
    return ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0;
  }

  function isSkippableLink(el) {
    const href = el.getAttribute('href') || '';
    if (!href || href === '#' || href.indexOf('#') === 0) return true;
    if (el.hasAttribute('data-no-history')) return true;
    if (el.getAttribute('target') === '_blank') return true;
    if (el.hasAttribute('download')) return true;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return true;
    return false;
  }

  function isInternalLink(el) {
    const href = el.getAttribute('href') || '';
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function fadeOutThenNavigate(url) {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* ignore */
    }
    document.body.classList.add('is-showing-loader', 'is-faded');
    window.setTimeout(() => {
      window.location.href = url;
    }, TRANSITION_MS);
  }

  function onDocumentClick(ev) {
    if (!hasLooksPage() || isModifiedClick(ev)) return;

    const anchor = ev.target.closest('a[href]');
    if (!anchor || isSkippableLink(anchor) || !isInternalLink(anchor)) return;

    if (
      document.querySelector('.looks[data-looks-product-modal="true"]') &&
      anchor.closest('.js-looksPostCopy') &&
      (anchor.getAttribute('href') || '').includes('/products/')
    ) {
      return;
    }

    const href = anchor.getAttribute('href');
    let url;
    try {
      url = new URL(href, window.location.origin).href;
    } catch (e) {
      return;
    }

    if (url === window.location.href) return;

    ev.preventDefault();
    fadeOutThenNavigate(url);
  }

  function initEnterFade() {
    if (!hasLooksPage()) return;

    let entering = false;
    try {
      entering = sessionStorage.getItem(STORAGE_KEY) === '1';
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }

    if (entering) {
      document.body.classList.add('is-showing-loader', 'is-faded');
      window.setTimeout(() => {
        document.body.classList.remove('is-faded');
      }, 50);
      window.setTimeout(() => {
        document.body.classList.remove('is-showing-loader');
      }, TRANSITION_MS + 100);
    }
  }

  function initImageLoading() {
    document.querySelectorAll('.looks img').forEach((img) => {
      if (img.complete) return;
      img.classList.add('is-loading');
      const onDone = () => {
        img.classList.remove('is-loading');
        img.removeEventListener('load', onDone);
        img.removeEventListener('error', onDone);
      };
      img.addEventListener('load', onDone);
      img.addEventListener('error', onDone);
    });
  }

  function init() {
    if (!hasLooksPage()) return;
    initEnterFade();
    initImageLoading();
    document.addEventListener('click', onDocumentClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
